var CBS = window.CBS || {};

CBS.mWeb = {}; // Namespace for mobile web

CBS.declareNS = function (ns) {
    var nsParts = ns.split('.');
    var nsLength = nsParts.length;
    var root = window;
    var i;

    for (i = 0; i < nsLength; i++) {
        if (typeof root[nsParts[i]] == 'undefined') root[nsParts[i]] = new Object();
        root = root[nsParts[i]];
    }
};

// TODO: Move these 2 + console.log replacement to polyfils.js
if (jQuery && !jQuery.fn.live) {
    jQuery.fn.live = function (evt, func) {
        $('body').on(evt, this.selector, func);
    };
}

if (jQuery) {
    jQuery.ajaxSetup({
        cache: true,
    });
}

// jQuery $.browser polyfil
(function () {
    if (jQuery && jQuery.browser) return;

    var matched, browser;

    // Use of jQuery.browser is frowned upon.
    // More details: http://api.jquery.com/jQuery.browser
    // jQuery.uaMatch maintained for back-compat
    jQuery.uaMatch = function (ua) {
        ua = ua.toLowerCase();

        var match =
            /(chrome)[ \/]([\w.]+)/.exec(ua) ||
            /(webkit)[ \/]([\w.]+)/.exec(ua) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
            /(msie) ([\w.]+)/.exec(ua) ||
            (ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
            [];

        return {
            browser: match[1] || '',
            version: match[2] || '0',
        };
    };

    matched = jQuery.uaMatch(navigator.userAgent);
    browser = {};

    if (matched.browser) {
        browser[matched.browser] = true;
        browser.version = matched.version;
    }

    // Chrome is Webkit, but Webkit is also Safari.
    if (browser.chrome) {
        browser.webkit = true;
    } else if (browser.webkit) {
        browser.safari = true;
    }

    jQuery.browser = browser;

    jQuery.sub = function () {
        function jQuerySub(selector, context) {
            return new jQuerySub.fn.init(selector, context);
        }

        jQuery.extend(true, jQuerySub, this);
        jQuerySub.superclass = this;
        jQuerySub.fn = jQuerySub.prototype = this();
        jQuerySub.fn.constructor = jQuerySub;
        jQuerySub.sub = this.sub;
        jQuerySub.fn.init = function init(selector, context) {
            if (context && context instanceof jQuery && !(context instanceof jQuerySub)) {
                context = jQuerySub(context);
            }

            return jQuery.fn.init.call(this, selector, context, rootjQuerySub);
        };
        jQuerySub.fn.init.prototype = jQuerySub.fn;
        var rootjQuerySub = jQuerySub(document);
        return jQuerySub;
    };
})();

CBS.Host = CBS.Host || '';
CBS.UserAgent = navigator.userAgent;
CBS.UserAuthStatus = CBS.UserAuthStatus || '';

CBS.Registry = CBS.Registry || {
    ssl: false,
    host: '',
    facebook_app_id: '',
    google_client_id: '',
    user_auth: false,
    homepage: false,
    platform: { isMobile: false, isWebView: false },
    chromecast: { receiver_id: null },
    recurly_public_key: null,
    login: {
        authToken: null,
        ui: {
            title: '',
            copy: '',
            signup_link: '',
        },
    },
    register: {},
    bd_delay: 5000,
    user: { id: null, sub_status: '', sb: 'sb|0' },
    context_override: {},
    yahoo_widgets: true,
    intlOverlay: false,
    brand: {
        international: false,
        property: 'US',
    },
};

(function () {
    var adsDeferred = $.Deferred();
    var trackingDeferred = $.Deferred();
    CBS.Promises = {
        Ads: {
            onLoad: function (callback) {
                adsDeferred.promise().done(callback);
            },
            resolve: function () {
                adsDeferred.resolve();
            },
        },
        Tracking: {
            onLoad: function (callback) {
                trackingDeferred.promise().done(callback);
            },
            resolve: function () {
                trackingDeferred.resolve();
            },
        },
    };
})();

window.CBSJSTemplates = {
    Helpers: {},
};

CBS.UserDate = function () {
    var nowDate = new Date();
    nowDate.setMinutes(nowDate.getMinutes() + (nowDate.getTimezoneOffset() - 240));
    var year = nowDate.getFullYear(),
        month = ('0' + (nowDate.getMonth() + 1)).slice(-2),
        day = ('0' + nowDate.getDate()).slice(-2),
        hours = ('0' + nowDate.getHours()).slice(-2),
        mins = nowDate.getMinutes();

    var floormin = Math.floor(mins / 5) * 5;
    if (floormin < 10) {
        floormin = '0' + floormin;
    }

    return year + '-' + month + '-' + day + '-' + hours + '-' + floormin;
};

CBS.CookieEnabled = function () {
    var testCookieName = 'cookieEnabledTest';
    var cookieEnabled = navigator.cookieEnabled ? true : false;
    if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
        document.cookie = testCookieName;
        cookieEnabled = document.cookie.indexOf(testCookieName) != -1 ? true : false;
    }
    if (cookieEnabled) {
        document.cookie = testCookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    return cookieEnabled;
};

// check FB login/connect status
CBS.FBStatus = function () {};

CBS.Message = {
    Show: function (message, klass) {
        $('div.cbs-message-notification').addClass(klass).html(message).fadeIn();
    },
    Clean: function () {
        $('div.cbs-message-notification').removeClass('info').removeClass('error').html('').hide();
    },
};

CBS.Loader = {
    Show: function (message) {
        $('#cbs--loader--master').html(message).fadeIn();
    },
    Hide: function () {
        $('#cbs--loader--master').html('').hide();
    },
};

CBS.getUID = function () {
    var __uid = $.cookie('CBS_CTC');

    try {
        if (__uid) {
            __uid = __uid.split('|');
            __uid = __uid[1];
        } else {
            __uid = '';
        }
    } catch (e) {
        __uid = '';
    }

    return __uid;
};
CBS.NoFrame = function () {};

CBS.Form = {};
CBS.Form.FormatPhone = function (number) {
    var regexObj = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (regexObj.test(number)) {
        var parts = number.match(regexObj);
        var phone = '';
        if (parts[1]) {
            phone += '1 (' + parts[1] + ') ';
        }
        phone += parts[2] + '-' + parts[3];
        return phone;
    } else {
        return number;
    }
};
String.prototype.parseLinks = function () {
    var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
    var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    var emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
    return this.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
        .replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
        .replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>');
};

String.prototype.parseTWHashTag = function () {
    return this.replace(/[#]+[A-Za-z0-9-_]+/g, function (t) {
        var tag = t.replace('#', '%23');
        return (
            '<a target="_blank" href="http://search.twitter.com/search?q=' + tag + '">' + t + '</a>'
        );
    });
};
String.prototype.parseTWUsername = function () {
    return this.replace(/[@]+[A-Za-z0-9-_]+/g, function (u) {
        var username = u.replace('@', '');
        return '<a target="_blank" href="http://www.twitter.com/' + username + '">' + u + '</a>';
    });
};
String.prototype.truncate = function (value) {
    return this.substr(0, value - 1) + (this.length > value ? '...' : '');
};
String.prototype.toNormalCase = function () {
    return this.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
    });
};
String.prototype.url_encode = function () {
    var str = $.trim((this + '').toString());
    return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
        .replace(/%20/g, '+');
};

jQuery.cookie = function (name, value, options) {
    if (typeof value != 'undefined') {
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (
            options.expires &&
            (typeof options.expires == 'number' || options.expires.toUTCString)
        ) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString();
        }
        var path = options.path ? '; path=' + options.path : '';
        var domain = options.domain ? '; domain=' + options.domain : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [
            name,
            '=',
            encodeURIComponent(value),
            expires,
            path,
            domain,
            secure,
        ].join('');
    } else {
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                if (cookie.substring(0, name.length + 1) == name + '=') {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};
CBS.CombinedCookie = {
    get: function (cookieName, key) {
        var cookie = $.cookie(cookieName);
        if (cookie) {
            var cookieObj = $.parseJSON(cookie);
            if (key in cookieObj) {
                return cookieObj[key];
            }
        }

        return null;
    },
    set: function (cookieName, key, value, expiration, path) {
        var cookieObj = {};

        if ($.cookie(cookieName)) {
            var decoded = $.parseJSON($.cookie(cookieName));
            if (typeof decoded === 'object') {
                cookieObj = decoded;
            }
        }
        cookieObj[key] = value;
        if (typeof expiration == 'undefined') {
            if (cookieObj['cookieExpiration']) {
                expiration = cookieObj['cookieExpiration'];
            }
        } else {
            cookieObj['cookieExpiration'] = expiration;
        }

        if (typeof path == 'undefined') {
            if (cookieObj['cookiePath']) {
                path = cookieObj['cookiePath'];
            } else {
                path = '/';
            }
        } else {
            cookieObj['cookiePath'] = path;
        }
        value = JSON.stringify(cookieObj);
        $.cookie(cookieName, value, { expires: expiration, path: path });
    },
};

CBS.UIHelper = {
    popup: {
        do_: function (container, action) {
            var $container = $(container);

            if (!$container.length) {
                console.log('Popup container is not defined.');
                return;
            }
            if (!$.fn.popup && !$.fn.bPopup) {
                console.log('Popup function is not defined.');
                return;
            }

            switch (action) {
                case 'open':
                    if (this.useNewPopup()) {
                        $container.bPopup();
                    } else {
                        window.scrollTo(0, 0);
                        $container.popup('open');
                    }
                    break;
                case 'close':
                    this.useNewPopup() ? $container.bPopup().close() : $container.popup('close');
                    break;
                default:
            }
        },
        open: function (container) {
            this.do_(container, 'open');
        },
        close: function (container) {
            this.do_(container, 'close');
        },
        useNewPopup: function () {
            // check if we can use the new popup fn
            if ($.fn.popup) return false;
            if ($.fn.bPopup) return true;
        },
    },
};

// Avoid `console` errors in browsers that lack a console, such as IE when dev tools is not open
(function () {
    var method;
    var noop = function () {};
    var methods = [
        'assert',
        'clear',
        'count',
        'debug',
        'dir',
        'dirxml',
        'error',
        'exception',
        'group',
        'groupCollapsed',
        'groupEnd',
        'info',
        'log',
        'markTimeline',
        'profile',
        'profileEnd',
        'table',
        'time',
        'timeEnd',
        'timeStamp',
        'trace',
        'warn',
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
})();

window.location.getParam = function (key) {
    var vars = [],
        hash;
    var q = this.search.substring(1).split('&');

    for (var i = 0; i < q.length; i++) {
        hash = q[i].split('=');
        vars[hash[0]] = hash[1];
    }
    return vars[key];
};

window.CBS = CBS;

$('body').trigger('CBSJSLoad');

$(document).ready(function () {
    if (!CBS.Registry.region.international) {
        if (!CBS.Registry.intlOverlay) {
            show_intl_popup();
        }
    }
});

function show_intl_popup() {}

(function () {
    function r(r, n, e) {
        var t = (n && e) || 0,
            u = 0;
        for (
            n = n || [],
                r.toLowerCase().replace(/[0-9a-f]{2}/g, function (r) {
                    16 > u && (n[t + u++] = y[r]);
                });
            16 > u;

        )
            n[t + u++] = 0;
        return n;
    }

    function n(r, n) {
        var e = n || 0,
            t = v;
        return (
            t[r[e++]] +
            t[r[e++]] +
            t[r[e++]] +
            t[r[e++]] +
            '-' +
            t[r[e++]] +
            t[r[e++]] +
            '-' +
            t[r[e++]] +
            t[r[e++]] +
            '-' +
            t[r[e++]] +
            t[r[e++]] +
            '-' +
            t[r[e++]] +
            t[r[e++]] +
            t[r[e++]] +
            t[r[e++]] +
            t[r[e++]] +
            t[r[e++]]
        );
    }

    function e(r, e, t) {
        var u = (e && t) || 0,
            a = e || [];
        r = r || {};
        var o = null != r.clockseq ? r.clockseq : g,
            f = null != r.msecs ? r.msecs : new Date().getTime(),
            c = null != r.nsecs ? r.nsecs : h + 1,
            i = f - w + (c - h) / 1e4;
        if (
            (0 > i && null == r.clockseq && (o = (o + 1) & 16383),
            (0 > i || f > w) && null == r.nsecs && (c = 0),
            c >= 1e4)
        )
            throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        (w = f), (h = c), (g = o), (f += 122192928e5);
        var s = (1e4 * (268435455 & f) + c) % 4294967296;
        (a[u++] = (s >>> 24) & 255),
            (a[u++] = (s >>> 16) & 255),
            (a[u++] = (s >>> 8) & 255),
            (a[u++] = 255 & s);
        var l = ((f / 4294967296) * 1e4) & 268435455;
        (a[u++] = (l >>> 8) & 255),
            (a[u++] = 255 & l),
            (a[u++] = ((l >>> 24) & 15) | 16),
            (a[u++] = (l >>> 16) & 255),
            (a[u++] = (o >>> 8) | 128),
            (a[u++] = 255 & o);
        for (var v = r.node || p, y = 0; 6 > y; y++) a[u + y] = v[y];
        return e ? e : n(a);
    }

    function t(r, e, t) {
        var a = (e && t) || 0;
        'string' == typeof r && ((e = 'binary' == r ? new l(16) : null), (r = null)), (r = r || {});
        var o = r.random || (r.rng || u)();
        if (((o[6] = (15 & o[6]) | 64), (o[8] = (63 & o[8]) | 128), e))
            for (var f = 0; 16 > f; f++) e[a + f] = o[f];
        return e || n(o);
    }

    var u,
        a = this,
        o = a.crypto || a.msCrypto;
    if ('function' == typeof a.require)
        try {
            var f = a.require('crypto').randomBytes;
            u =
                f &&
                function () {
                    return f(16);
                };
        } catch (c) {}
    if (!u && o && o.getRandomValues) {
        var i = new Uint8Array(16);
        u = function () {
            return o.getRandomValues(i), i;
        };
    }
    if (!u) {
        var s = new Array(16);
        u = function () {
            for (var r, n = 0; 16 > n; n++)
                0 === (3 & n) && (r = 4294967296 * Math.random()),
                    (s[n] = (r >>> ((3 & n) << 3)) & 255);
            return s;
        };
    }
    for (
        var l = 'function' == typeof a.Buffer ? a.Buffer : Array, v = [], y = {}, d = 0;
        256 > d;
        d++
    )
        (v[d] = (d + 256).toString(16).substr(1)), (y[v[d]] = d);
    var m = u(),
        p = [1 | m[0], m[1], m[2], m[3], m[4], m[5]],
        g = 16383 & ((m[6] << 8) | m[7]),
        w = 0,
        h = 0,
        q = t;
    (q.v1 = e), (q.v4 = t), (q.parse = r), (q.unparse = n), (q.BufferClass = l);
    var C = a.uuid;
    (q.noConflict = function () {
        return (a.uuid = C), q;
    }),
        (a.uuid = q);
}).call(window);
